import { render, staticRenderFns } from "./discounts_allowed.vue?vue&type=template&id=252e773e&"
import script from "./discounts_allowed.vue?vue&type=script&lang=js&"
export * from "./discounts_allowed.vue?vue&type=script&lang=js&"
import style0 from "./discounts_allowed.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports